import { GET_PAYMENT_METHODS, PAYMENT_METHOD_DELETE } from '@gameday/common/constants/endpoints'

export default {
  getPaymentMethods: GET_PAYMENT_METHODS, // 'gamedayapi/braintree/getpaymentmethods',
  deletePaymentMethod: PAYMENT_METHOD_DELETE, // 'gamedayapi/braintree/deletepaymentmethod'
}
